module.exports = __webpack_public_path__ + "static/Graphik-Medium-Web-cc2d92508ce1905a30a0ab3a5c00eac1.woff2";